import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'ordinalDate',
  standalone: false
})
export class OrdinalDatePipe implements PipeTransform {
  constructor(public translateService: TranslateService) { }

  transform(date: number | string): string {
    if (!date) { return ''; }
    if (typeof date === 'number') { date = date.toString(); }

    let ordinalKey = 'ORDINAL_DATES.default';

    switch (date.substr(-1)) {
      case '1':
        if (date.substr(-2) !== '11') { ordinalKey = 'ORDINAL_DATES.first'; }
        break;
      case '2':
        if (date.substr(-2) !== '12') { ordinalKey = 'ORDINAL_DATES.second'; }
        break;
      case '3':
        if (date.substr(-2) !== '13') { ordinalKey = 'ORDINAL_DATES.third'; }
        break;
      default:
    }

    return date + this.translateService.instant(ordinalKey);
  }
}
